import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import Navbar from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function Lubbock() {
  return (
    <section>
<Helmet>
  <title>Lubbock Website Design for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design creates custom-coded, SEO-powered websites and brand strategies for women entrepreneurs and female founders in Lubbock, Texas. Mobile-friendly, conversion-focused, and designed to elevate women-led businesses."
  />
  <meta
    name="keywords"
    content="Lubbock web design for women entrepreneurs, Lubbock TX female founder websites, Lubbock women-owned business websites, custom websites Lubbock Texas, SEO web design for women Lubbock, Lubbock startup website design, branding for women entrepreneurs Lubbock TX, creative agency Lubbock women-led, upscale website design Lubbock TX, mobile-first websites Lubbock, professional websites for Lubbock women in business, strategic web design Lubbock TX, tailored websites for Lubbock female founders, Lubbock digital strategy and branding, elegant website design Lubbock women entrepreneurs, Lubbock personal brand websites, high-converting websites Lubbock TX, Lubbock founder-focused design studio, women in tech Lubbock web design, Lubbock conversion-optimized websites, React website design Lubbock women-owned brands, scalable websites for Lubbock startups, premium website design for Lubbock business women, Lubbock TX creative web design studio, women-led business websites Lubbock TX, Lubbock SEO websites for women-owned brands, digital presence for Lubbock entrepreneurs, Lubbock professional services website design, custom web development Lubbock TX for women founders, elevate your Lubbock brand online"
  />
</Helmet>


      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <Navbar />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Lubbock Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Serving women-owned businesses in Lubbock with high-converting websites and SEO that helps you rise above the noise and attract your ideal clients.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>






      {/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We guide Lubbock’s women entrepreneurs through a clear, creative process that results in websites that grow your brand.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Discovery & Vision",
        desc: "Understanding your Lubbock business goals and ideal clients to craft your unique website.",
      },
      {
        step: 2,
        title: "Design Creation",
        desc: "Designing a beautiful, mobile-optimized website tailored to your brand’s personality.",
      },
      {
        step: 3,
        title: "SEO Tailored for Lubbock",
        desc: "Implementing local SEO strategies to help your business get discovered by Lubbock clients.",
      },
      {
        step: 4,
        title: "Launch & Grow",
        desc: "Launching your site and providing ongoing support to help your brand flourish.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="client portal template, notion-style client dashboard, CRM for coaches, portal for 1:1 clients, private course dashboard, membership site template, custom dashboard for online business, onboarding portal for clients, student dashboard template, dashboard for course creators"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>





      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Helping{" "}
              <span className="italic text-black bg-[#CFF098]">
                Lubbock Women Entrepreneurs
              </span>{" "}
              Create an{" "}
              <span className="italic text-black bg-[#CFF098]">
                Impactful Online Brand
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              We specialize in web design and SEO for women-led businesses in Lubbock—from coaches to creatives to small business founders. Our mission is to make your online presence as strong, strategic, and stunning as the work you do.
              <br />
              <br />
              With a focus on clarity and conversion, we help you grow with confidence and show up as the go-to expert in your field.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Let’s bring your vision to life—with strategy, design, and SEO that works.
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="e-commerce funnel template, shopify sales funnel, digital product sales page, 
digital product template, Gumroad product page template, lead magnet funnel for coaches, React product landing page, passive income website template, stripe checkout website, course sales funnel"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default Lubbock;
